export default __webpack_public_path__ + "static/media/staff-user.9de6aeb4.svg";